import axios from 'axios'
import authenticationMixin from '@/mixins/authentication'
import env from '@/mixins/env'

// import router from '../main'

function getToken (token, refresh) {
  return new Promise((resolve, reject) => {
    let currentTime = new Date()
    let expireTime = new Date()

    if (token && token.expire) {
      expireTime = new Date(token.expire)
    }

    if (currentTime < expireTime) {
      resolve(token.token)
    } else {
      if (refresh === null) {
        authenticationMixin.methods.getTokens().then(response => {
          if (!response) {
            window.location = env.api_root() + '/?' + env.params()
          } else {
            let expireTime = new Date()

            expireTime.setMinutes(expireTime.getMinutes() + 5)

            this.$store.state.token = {
              'token': response.access,
              'expire': expireTime
            }

            this.$store.state.refreshToken = response.refresh

            window.$cookies.set('va-token', this.$store.state.token)
            window.$cookies.set('va-resfresh-token', this.$store.state.refreshToken)

            axios({
              method: 'post',
              url: env.api_url() + '/token/refresh/',
              data: {
                refresh: response.refresh
              }
            }).then((response) => {
              if (response.status === 200) {
                let expireTime = new Date()

                expireTime.setMinutes(expireTime.getMinutes() + 5)

                window.$cookies.set('va-token', {
                  'token': response.data.access,
                  'expire': expireTime
                })

                resolve(response.data.access)
              }
            }).catch((error) => {
              if (error) {
                window.location = env.api_root() + '/?' + env.params()
              }
            })
          }
        })
      } else {
        axios({
          method: 'post',
          url: env.api_url() + '/token/refresh/',
          data: {
            refresh: refresh
          }
        }).then((response) => {
          if (response.status === 200) {
            let expireTime = new Date()

            expireTime.setMinutes(expireTime.getMinutes() + 5)

            resolve(response.data.access)
          }
        }).catch((error) => {
          if (error) {
            window.location = env.api_root() + '/?' + env.params()
          }
        })
      }
    }
  })
}

export default getToken



// WEBPACK FOOTER //
// ./src/managers/getToken.js